import React from 'react'
import {Box} from '@chakra-ui/react'

interface EditorialFullPageProps {
    pageId: string
    children: React.ReactNode
}

/**
 * Full Page layout for Page Designer editorial pages.
 * Page type: fullPage
 *
 * Standard header, no fixed/transparent behavior.
 */
const EditorialFullPage = ({pageId, children}: EditorialFullPageProps): JSX.Element => {
    return (
        <Box data-testid={`editorial-${pageId}`} id={pageId}>
            {children}
        </Box>
    )
}

export {EditorialFullPage}
